<template>
  <transition name="modal">
    <div class="modal-mask chat" :style="{height:screenHeight}">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              default footer
              <button class="modal-default-button">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { hasNotch, NOTCH_HEIGHT } from '../utils/checkDevice'
import { mapMutations } from 'vuex'
export default {
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    ...mapMutations([
      'SET_CHAT'
    ])
  },
  created () {
    this.screenHeight = hasNotch() ? (screen.height - NOTCH_HEIGHT) + 'px' : screen.height + 'px'
  }
}
</script>

<style lang="scss" scoped>

</style>
